// extracted by mini-css-extract-plugin
module.exports = {"container":"CashbackCell_container__izYlv","button":"CashbackCell_button__62WH4"};